export default __webpack_public_path__ + "static/media/bumpRound.fb1b1725.png";